import { DATE_FORMAT } from '@app/configs/dateTime';
import { getLocalDateTime } from '@app/utils/time';
import formatAmount from '@modules/calculator/utils/formatAmount';
export const mapPastLoansToColumns = (pastLoans, t) => {
    return pastLoans.map((loan) => {
        const loanAmount = parseFloat(loan.amount);
        const collectedAmount = parseFloat(loan.collectedAmount);
        const collectedPercentage = loanAmount > 0 ? Math.round((collectedAmount / loanAmount) * 100) : 0;
        return {
            id: loan.id,
            creationDate: getLocalDateTime(loan.createdAt, DATE_FORMAT.dateDash),
            loanId: loan.id,
            status: loan.status,
            purpose: loan.purpose,
            period: `${loan.period} ${t('financing.investing_page_table.months')}`,
            requested: `${formatAmount(loan.amount)}`,
            collected: `${formatAmount(loan.collectedAmount)} (${collectedPercentage}%)`,
        };
    });
};
